import {createSelector} from 'reselect';

export const selectUserModel = (state: DefaultRootState) => state.user
export const selectLoadingModel = (state: DefaultRootState) => state.loading

export const selectAgentDetailsDrawer = createSelector(selectUserModel, (user) => user.detailsDrawer || {})

export const selectCreateUserDrawer = createSelector(selectUserModel, (user) => user.drawer)
export const selectRoles = createSelector(selectUserModel, (user) => user.conversionalRoles || [])
export const selectTransferableRoles = createSelector(selectUserModel, (user) => user.transferableRoles || [])

export const selectDrawerVisible = createSelector(selectCreateUserDrawer, (drawer) => drawer?.visible)
export const selectDrawerBranchId = createSelector(selectCreateUserDrawer, (drawer) => drawer?.branch_id)

export const selectCreateUserLoading = createSelector(selectLoadingModel, (loading) => loading?.effects?.['user/create'] || false)

export const selectAgentDetails = createSelector(
  [selectUserModel, (_, agentId) => agentId],
  (agents, agentId) => agents?.agentDetails?.[agentId] || {}
)
